import React, {useState} from "react";
import {Formik} from "formik";
import {connect} from "react-redux";
import {TextField} from "@material-ui/core";
import {Link, withRouter} from "react-router-dom";
import {FormattedMessage, injectIntl} from "react-intl";
import * as auth from "../../../store/ducks/auth.duck";
import {requestPassword} from "../../../crud/auth.crud";
import {makeStyles, withStyles} from '@material-ui/core/styles';
import clsx from "clsx";
import royalimage from '../../../assets/images/royal-flora-logo2x.png';
import Translate from "../../../utils/utils";

const ForgotPassword = (props) => {
    const {intl} = props;
    const [loading, setLoading] = useState(false);
    const [loadingButtonStyle, setLoadingButtonStyle] = useState({
        paddingRight: "2.5rem"
    });
    const CssTextField = withStyles({
        root: {
            "& label.Mui-focused": {
                color: "#c32e95"
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: "#c32e95"
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#9f8a99"
                },
                "&:hover fieldset": {
                    borderColor: "#c32e95"
                },
                "&.Mui-focused fieldset": {
                    borderColor: "#c32e95"
                }
            }
        }
    })(TextField);

    const useStyles = makeStyles(theme => ({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(0),
        },
        dense: {
            marginTop: theme.spacing(2),
        },
        menu: {
            width: 200,
        },
    }));
    const classes = useStyles();

    const enableLoading = () => {
        setLoading(true);
        setLoadingButtonStyle({paddingRight: "3.5rem"});
    };

    const disableLoading = () => {
        setLoading(false);
        setLoadingButtonStyle({paddingRight: "2.5rem"});
    };


    return (
        <div className="kt-login__body">
            <div className="kt-login__icon">
                <img src={royalimage} alt=""/>
            </div>
            <div className="kt-login__form">
                <div className="kt-login__title">
                    <h3>
                        <FormattedMessage id="AUTH.BUTTON.FORGOT_PASSWORD"/>
                    </h3>
                </div>

                <Formik
                    initialValues={{email: ""}}
                    validate={values => {
                        const errors = {};

                        if (!values.email) {
                            errors.email = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        ) {
                            errors.email = intl.formatMessage({
                                id: "AUTH.VALIDATION.INVALID_FIELD"
                            });
                        }

                        return errors;
                    }}
                    onSubmit={(values, {setStatus, setSubmitting}) => {
                        enableLoading();
                        requestPassword(values.email)
                            .then(({data: {message}}) => {
                                disableLoading()
                                setStatus(message)
                                setTimeout(() => {
                                    props.history.push('/auth/reset-password')
                                }, 3000)
                            })
                            .catch((error) => {
                                if (error.message === 'Network Error') {
                                    setStatus(error.message);
                                    disableLoading();
                                    setSubmitting(false);
                                    return;
                                }
                                const {response: {data: {errors: {email}}}} = error
                                setSubmitting(false);
                                disableLoading()
                                setStatus(email[0]);
                            });
                    }}
                >
                    {({
                          values,
                          status,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting
                      }) => (
                        <form onSubmit={handleSubmit} className="kt-form">
                            {status && (
                                <div role="alert" className="alert alert-danger">
                                    <div className="alert-text">{status}</div>
                                </div>
                            )}

                            <div className="form-group">
                                <CssTextField
                                    className={clsx(classes.textField, classes.dense)}
                                    variant="outlined"
                                    label={<Translate id="DIALOG.FORM.EMAIL"/>}
                                    margin="normal"
                                    type="email"
                                    fullWidth={true}
                                    name="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.email}
                                    helpertext={touched?.email && errors?.email}
                                    error={Boolean(touched?.email && errors?.email)}
                                />
                            </div>

                            <div className="kt-login__actions">
                                <button
                                    id="kt_login_signin_submit"
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                                        {
                                            "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                                        }
                                    )}`}
                                    style={loadingButtonStyle}
                                >
                                    <FormattedMessage id="PASSWORD.FORM.RESET"/>
                                </button>
                            </div>
                            <div className="kt-login__actions">
                                <Link
                                    to="/auth/login"
                                    className="kt-link kt-login__link-forgot"
                                >
                                    <FormattedMessage id="AUTH.BUTTON.LOGIN"/>
                                </Link>

                                <Link
                                    to="/auth/reset-password"
                                    className="kt-link kt-login__link-forgot"
                                >
                                    <FormattedMessage id="AUTH.BUTTON.HAVE_THE_CODE"/>
                                </Link>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default injectIntl(withRouter(connect(null, auth.actions)(ForgotPassword)));
